<template>   
    <div class="submain__terrenos-custom">
        <div class="line__vertical-mains"></div>
        <button-back/>
        <div v-if="locations.length > 0" class="map_filter">
             <div class="select__box box-terrenos">
                 <Range class="ranges-mobile" v-if="locations.length > 0 && filtersCalculated" :locations="locations" @change="changeRange" :rangeFilter="rangeSliderFilter" :rangeFilterPrice="rangeFilterPrice"/>  
                <Availables class="availables-mobile" :type="type" :existFilter="existFilter" :amountAvailables="amountAvailables" />
                <!-- <Promotion class="promotion_mobile">24</Promotion> -->
             </div>
            <div class="maphighlight__box">
                <h1 class="caption__select">
                    <span>Seleccione un terreno, clic para ver detalles</span>
                </h1>
                <map-highlight :img="img" :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :type="type" :nivel="nivel" />
                <Button :img="img" :id="id" :desarrollo="desarrollo" :nivel="nivel" :levelId="levelId" :url="url" />
                <div class="line_horizontal ranges-desk"></div>
                
            </div>
            <div class="select__box ">
                <!-- <Select v-if="locations.length > 0 && rangeFilter.length > 0" :locations="locations" @change="changeRange" :rangeFilter="rangeFilter" /> -->
                <Availables class="availables-desk" :type="type" :existFilter="existFilter" :amountAvailables="amountAvailables" />
                <Range class="ranges-desk" v-if="locations.length > 0 && filtersCalculated" :locations="locations" @change="changeRange" :rangeFilter="rangeSliderFilter" :rangeFilterPrice="rangeFilterPrice"/>  
               <!--  <Promotion class="promotion_web">24</Promotion> -->
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MapHighlight from "../../../core/MapHighlight.vue";
import ButtonBack from "../../../core/ButtonBack";
import Button from "../../../core/Button.vue";
import Availables from "../../../core/Availables.vue";
//import Select from "../../../core/Select.vue";
import Range from "../../../core/Range.vue";
/* import Promotion from "../../../core/Promotion"; */

export default {
    name: "Main",
    components: {
        MapHighlight,
        Button,
        ButtonBack,
        Availables,
        //Select,
        Range,
        /* Promotion */
    }, 
    data() {
        return {
            id: 36,
            levelId: this.$route.params.id,
            type: "terreno",
            desarrollo: "canadas_terrenos-priv",
            arrFilteredLocations: [],
            nivel: "availability",
            url: `nombre_nivel_te=${this.$route.params.privada}/detalles`,
            micrositeUrl: "https://www.tresmarias.com.mx/senderos/terrenos",
            privadas: {
                PRIVADA14: {
                    name: 'privada14',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/terrenos/privadas/privada14.png',
                    width: '1350',
                    id: 36,
                    levelId: this.$route.params.id,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.privada}/detalles`,
                    height: '1889',
                    transform: '',
                    viewBox: '0 0 1350 1889'
                },
                PRIVADA15: {
                    name: 'privada15',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/terrenos/privadas/privada15.png',
                    width: '3552',
                    id: 36,
                    levelId: this.$route.params.id,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.privada}/detalles`,
                    height: '1441',
                    transform: '',
                    viewBox: '0 0 3552 1441'
                },
                PRIVADA22: {
                    name: 'privada22',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/terrenos/privadas/privada22.png',
                    width: '2252',
                    id: 36,
                    levelId: this.$route.params.id,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.privada}/detalles`,
                    height: '2032',
                    transform: '',
                    viewBox: '0 0 2252 2023'
                },
                PRIVADA28: {
                    name: 'privada28',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/terrenos/privadas/privada28.png',
                    width: '3524',
                    id: 36,
                    levelId: this.$route.params.id,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.privada}/detalles`,
                    height: '1616',
                    transform: '',
                    viewBox: '0 0 3524 1616'
                },
                
          },
            rangeSliderFilter:[null,null],
            rangeFilterPrice:[null,null],
            rangeFilter: [
              { min: 0, max: 0 }
          ],
            filtersCalculated: false
        };
    },
    computed: {
        ...mapGetters({
            locations: "getLocations",
            filterModelos: "getStatusFilterModelos"
        }),
        development() {
            return { id: this.id, level: this.levelId };
        },
        img() {
            const privada = this.$route.params.privada;
            const privadaSeleccionada = this.privadas[privada];
            return privadaSeleccionada;
        },
        amountAvailables() {
            const filteredAvailables = this.existFilter;
            const newArrfiltered = filteredAvailables.filter(
                (item) => item.status == 2
            );
            return newArrfiltered;
        },
        existFilter() {
            let arrExistFilter;
            if (this.rangeFilter) {
                arrExistFilter = this.arrFilteredLocations;
            } else if (this.rangeFilter === false) {
                arrExistFilter = this.locations;
            }
            return arrExistFilter;
        },
    },
    methods: {
        ...mapActions(["getAvailableLocations", "clearCoords"]),
        changeRange(arrFilter) {
            this.arrFilteredLocations = arrFilter;
        },

    },
    async created() {
      await this.getAvailableLocations(this.development);
    },
    async beforeDestroy() {
        await this.clearCoords();
    },
    watch: {
    locations(newVal) {
      if (newVal.length > 0) {
        const m2tValues = newVal
          .filter(item => item.m2t != null)
          .map(item => Number(item.m2t));

        if (m2tValues.length > 0) {
          const min = Math.floor(Math.min(...m2tValues));
          const max = Math.ceil(Math.max(...m2tValues)); 

          this.rangeSliderFilter = [min, max];
        } else {
          this.rangeSliderFilter = [0, 0];
        }

        const prices = newVal.map(item => item.value);
        if (prices.length > 0) {
          const minPrice = Math.floor(Math.min(...prices));
          const maxPrice = Math.ceil(Math.max(...prices));

          this.rangeFilterPrice = [minPrice, maxPrice];
          const step = Math.ceil((maxPrice - minPrice + 1) / 3);

          this.rangeFilter = [
            { min: minPrice, max: minPrice + step - 1 },
            { min: minPrice + step, max: minPrice + step * 2 - 1 },
            { min: minPrice + step * 2, max: maxPrice },
          ];
          this.filtersCalculated = true;
        } else {
          this.rangeFilterPrice = [null, null];
          this.rangeFilter = [];
        }

        this.arrFilteredLocations = newVal;
      }
    }
  }
};
</script>
<style>
@media (min-width:1201px){
    .box-terrenos{
        display: none;
    }
}
</style>
